var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEncryption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 32.5C48.35 32.5 49.175 32.6 50 32.725V25C50 23.6739 49.4732 22.4021 48.5355 21.4645C47.5979 20.5268 46.3261 20 45 20H42.5V15C42.5 8.1 36.9 2.5 30 2.5C23.1 2.5 17.5 8.1 17.5 15V20H15C13.6739 20 12.4021 20.5268 11.4645 21.4645C10.5268 22.4021 10 23.6739 10 25V50C10 52.775 12.225 55 15 55H34.525C33.25 52.8 32.5 50.25 32.5 47.5C32.5 39.225 39.225 32.5 47.5 32.5ZM22.5 15C22.5 10.85 25.85 7.5 30 7.5C34.15 7.5 37.5 10.85 37.5 15V20H22.5V15ZM30 42.5C29.0111 42.5 28.0444 42.2068 27.2221 41.6573C26.3999 41.1079 25.759 40.327 25.3806 39.4134C25.0022 38.4998 24.9031 37.4945 25.0961 36.5245C25.289 35.5546 25.7652 34.6637 26.4645 33.9645C27.1637 33.2652 28.0546 32.789 29.0245 32.5961C29.9945 32.4031 30.9998 32.5022 31.9134 32.8806C32.827 33.259 33.6079 33.8999 34.1573 34.7221C34.7068 35.5444 35 36.5111 35 37.5C35 40.275 32.775 42.5 30 42.5ZM56.25 43.125L44.375 55L37.5 47.5L40.4 44.6L44.375 48.575L53.35 39.6L56.25 43.125Z",
    fill: "#044D9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncryption);
export default __webpack_public_path__ + "static/media/encryption.4a084e98c684eb754692ea24e34154ce.svg";
export { ForwardRef as ReactComponent };